/* @flow */
import React, { Component } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import type { ContextRouter } from 'react-router';
import Well from '../../components/Well';

import TutorHeader from './components/TutorHeader';
import TutorToolbar from './components/TutorToolbar';
import TutorJobs from './components/TutorJobs';

import type { Tutor_tutor } from './__generated__/Tutor_tutor.graphql';
import enhancer from '../../enhancer';

type Props = {
  tutor: Tutor_tutor,
} & ContextRouter;

type State = {
  confirm: ?{
    title: string,
    title: string,
    callback: () => void,
  },
};

class Tutor extends Component<Props, State> {
  handleApprove = () => {
    const { tutor, history } = this.props;
    history.push(`/admin/tutor/${String(tutor.id)}/approve`);
  };

  handleLock = () => {
    // TODO
  };

  handleUnlock = () => {
    // TODO
  };

  render() {
    const { tutor } = this.props;

    return (
      <Well>
        <TutorToolbar
          tutor={tutor}
          handleApprove={this.handleApprove}
          handleLock={this.handleLock}
          handleUnlock={this.handleUnlock}
        />
        <div style={{ padding: 10 }}>
          <TutorHeader tutor={tutor} />
        </div>
        <TutorJobs tutor={tutor} />
      </Well>
    );
  }
}

const query = graphql`
  query TutorAdminQuery($nodeId: ID!) {
    tutor: node(id: $nodeId) {
      ...Tutor_tutor
    }
  }
`;

export default enhancer(Tutor, {
  relay: {
    query,
    create: () =>
      createFragmentContainer(Tutor, {
        tutor: graphql`
          fragment Tutor_tutor on Tutor {
            id
            ...TutorJobs_tutor
            ...TutorHeader_tutor
            ...TutorToolbar_tutor
          }
        `,
      }),
  },
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/Tutor.js